module.exports = __webpack_public_path__ + "src/routes/home/toDay.jpg?213501fd";


//////////////////
// WEBPACK FOOTER
// ./src/routes/home/toDay.jpg
// module id = 2852
// module chunks = 1